import { useState, useContext, useMemo, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useProjectStore } from 'Store/Project'
import { PileExecutionAttachmentContext } from './Context'
import { shallow } from 'zustand/shallow'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'

const ViewModel = () => {
  const modalsRoot = document.getElementById('root-modals') || document.body
  const { id: projectId } = useParams<{ id: string }>()
  const { open, currentPileHoleId, setOpen, setCurrentPileHoleId } = useContext(
    PileExecutionAttachmentContext
  )
  const pileHole = useProjectStore(state => state.pileHole, shallow)
  const pileHole1 = useMemo(
    () => (pileHole?.itemInventory ?? []).find((p: any) => p.id === currentPileHoleId.pile1HoleId),
    [pileHole, currentPileHoleId]
  )
  const pileHole2 = useMemo(
    () => (pileHole?.itemInventory ?? []).find((p: any) => p.id === currentPileHoleId.pile2HoleId),
    [pileHole, currentPileHoleId]
  )

  const { data, getAll, view, create, remove } = useProjectStore(
    state => ({
      data: state.weldPictures,
      getAll: state.getAllWeldPictures,
      view: state.viewWeldPicture,
      create: state.createWeldPicture,
      remove: state.deleteWeldPicture,
    }),
    shallow
  )

  const processedData = useMemo(() => {
    return data.map((d: any) => ({
      ...d,
      url: view(d.url),
    }))
  }, [data, view])

  const [openLightBox, setOpenLightBox] = useState<boolean>(false)
  const [lightBoxImage, setLightBoxImage] = useState<string>('' as any)
  const [lightBoxAlt, setLightBoxAlt] = useState<string>('' as any)

  const openImage = (id: number) => {
    const finded = data.find((d: any) => d.id === id)
    if (finded) {
      const imgPath = view(finded.url)
      const imgFileName = `Pile Weld Picture`
      setLightBoxImage(imgPath)
      setLightBoxAlt(imgFileName)
      setOpenLightBox(true)
    }
  }

  const closeImage = () => {
    setOpenLightBox(false)
  }

  const fetchWeldPictures = () => {
    if (open) {
      if (projectId && currentPileHoleId.pile1HoleId && currentPileHoleId.pile2HoleId) {
        getAll(projectId, currentPileHoleId.pile2HoleId).then(({ success, data }) => {
          if (!success) {
            toast.error('Error fetching weld pictures : ' + data)
          }
        })
      }
    }
  }

  const onClose = () => {
    setOpen(false)
    setCurrentPileHoleId({ pile1HoleId: '', pile2HoleId: '' })
  }

  const onSubmit = (picture: File | undefined) => {
    if (picture !== undefined && picture !== null) {
      if (projectId && currentPileHoleId.pile2HoleId)
        create(projectId, currentPileHoleId.pile2HoleId, { picture }).then(({ success, data }) => {
          if (!success) {
            toast.error('Error creating weld pictures : ' + data)
          } else {
            toast.success('Weld picture created successfully')
            fetchWeldPictures()
          }
        })
    } else {
      toast.error('กรุณาอัพโหลดรูปภาพ')
      return
    }
  }

  const onRemove = (picId: string) => {
    Swal.fire({
      icon: 'warning',
      title: 'คุณแน่ใจที่จะลบรูปภาพนี้?',
      showCancelButton: true,
      confirmButtonText: 'ลบ',
      cancelButtonText: 'ยกเลิก',
    }).then(result => {
      if (result.isConfirmed) {
        if (projectId && currentPileHoleId.pile2HoleId)
          remove(projectId, currentPileHoleId.pile2HoleId, picId).then(({ success, data }) => {
            if (!success) {
              toast.error('Error removing weld pictures : ' + data)
            } else {
              toast.success('Weld picture removed successfully')
              fetchWeldPictures()
            }
          })
      }
    })
  }

  useEffect(() => {
    fetchWeldPictures()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, currentPileHoleId, open])

  return {
    data: processedData,
    lightBoxImage,
    lightBoxAlt,
    openLightBox,
    openImage,
    closeImage,
    modalsRoot,
    open,
    currentPileHoleId,
    pileHole1,
    pileHole2,
    onClose,
    onSubmit,
    onRemove,
  }
}

export default ViewModel
